/**
 * axios setup to use mock service
 */
import { router } from "@/router";
import axios from "axios";
import { useAuthStore } from "@/stores/auth-store";
const axiosServices = axios.create();

const saveToken = (token) => {
  localStorage.setItem("token", token);
};

const saveTokenExpiredAt = (time) => {
  localStorage.setItem("token_expired_at", time);
};
const getToken = () => {
  return localStorage.getItem("token");
};

const getTokenExpiredAt = () => {
  return localStorage.getItem("token_expired_at");
};

axiosServices.interceptors.request.use(
  async (config) => {
    const token = getToken();
    const tokenExpiredAt = getTokenExpiredAt();
    const now = new Date();

    if (token && tokenExpiredAt) {
      const expiredAt = new Date(tokenExpiredAt).getTime();
      const nowTime = now.getTime();

      const bufferTime = 1000 * 60 * 1000;
      if (expiredAt - nowTime <= bufferTime) {
        try {
          const response = await axios.post(
            `${process.env.VUE_APP_BE_URL}/api/users/token/refresh/`,
            {},
            {
              headers: {
                "X-External-Token": `${process.env.VUE_APP_TOKEN}`,
              },
            }
          );

          saveToken(response.data.access);
          saveTokenExpiredAt(response.data.token_expired_at);

          config.headers.Authorization = `Bearer ${response.data.access}`;
        } catch (error) {
          useAuthStore().loader = false;
          return Promise.reject(error);
        }
      } else {
        if (config.url.includes("/auth-user")) {
          config.headers.Authorization = `${process.env.VUE_APP_TOKEN}`;
        } else {
          config.headers.Authorization = `Bearer ${token}`;
        }
        if (!useAuthStore().loader) {
          useAuthStore().loader = true;
        }
      }
    }

    return config;
  },
  (error) => {
    useAuthStore().loader = false;
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  async (response) => {
    const auth = useAuthStore();
    auth.loader = false;
    auth.stopLog = false;
    return await response;
  },
  async (error) => {
    const auth = useAuthStore();
    auth.loader = false;
    const originalRequest = error.config || {};
    const status = error.response?.status;
    const currentRoute = router.currentRoute.value?.name;

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      auth.logout();
      router.push("/login");
    } else if (status === 404 || (status >= 500 && status <= 599)) {
      // Jangan redirect ke halaman error untuk kegagalan API.
      // Redirect hanya untuk request halaman/navigasi.
      const url = originalRequest.url || "";
      const isApiCall =
        url.includes("/api/") ||
        (originalRequest.headers?.Accept || "").includes("application/json");
      if (!isApiCall) {
        const target = status === 404 ? "error-404" : "error-500";
        if (currentRoute !== target) {
          router.push(`/${target}`);
        }
      }
    } else if (status === 400 || status === 422) {
      console.log(status);
    } else {
      console.log(status);
    }

    return Promise.reject(error);
  }
);
export default axiosServices;
